exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-item[data-v-df95885e] {\n  position: relative;\n  top: 2px;\n}\n", ""]);

// exports
